<!--
 * @Description: 综合绩效查询
 * @Author: maqinghe 
 * @Date: 2023年06月09日 13:04:22
-->
<template>
  <div class='declare-page atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" ref="searchForm" :rules="rules" class="atb-input" :show-message="false" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <div class="query-where">
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover
                placement="bottom-start"
                width="420"
                popper-class="popper-tree declare-dep"
                @hide="handledHide"
                trigger="click">
                <!-- <el-input v-model="searchDep" placeholder="请输入部门名称搜索" clearable></el-input> -->
                <el-tree
                  :props="defaultProps"
                  :data="treeData"
                  show-checkbox
                  node-key='id'
                  ref="tree"
                  highlight-current
                  :default-expanded-keys="expandedData"
                  @check="handleCheckChange">
                </el-tree>
                <el-input slot="reference" v-model="department" placeholder="请选择部门" clearable></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item class="flex-form-item" label="上级">
              <selecter v-model="searchParam.superiorNo" placeholder="输入工号或姓名查询" :name="searchParam.superiorName"></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="姓名">
              <el-input v-model="searchParam.wkName" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item class="flex-form-item" label="评级">
              <el-select clearable v-model="searchParam.oecResult" placeholder="评级">
                <el-option v-for="item in oecLevel" :key="item.value" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="评级状态">
              <common-select ref="status" v-model="searchParam.status" :list="oecStatusList" optLabel="itemDesc" optValue="itemValue" placeholder="评级状态" clearable></common-select>
            </el-form-item>
          </div>

          <div class="query-operation">
            <el-form-item label="年份" prop="year">
              <el-date-picker v-model="searchParam.year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
            </el-form-item>
            <el-form-item label="期次" prop="period">
              <common-select ref="period" v-model="searchParam.period" :list="periodList" optLabel="label" optValue="value" placeholder="期次" clearable></common-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="exportExcel">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" @click="exportMulti">批量导出</el-button>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-button type="downloadTemplate" style="width: 110px!important;" @click="exportTask">综合考核表导出</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="summary">
        <span class="item-data">当期参评人数:<span class="num">{{currentSum.total || 0}}</span></span>
        <span class="item-data">当期应得A人数:<span class="num">{{currentSum.regulationA || 0}}</span></span>
        <span class="item-data">当期应得C人数:<span class="num">{{currentSum.regulationC || 0}}</span></span>
        <span class="item-data">实际当期得A人数:<span :class="currentSum.realityA > currentSum.regulationA ? warnNum : nomalNum">{{currentSum.realityA || 0}}</span></span>
        <span class="item-data">实际当期得C人数:<span :class="currentSum.realityC < currentSum.regulationC ? warnNum : nomalNum">{{currentSum.realityC || 0}}</span></span>
        <!-- <span class="item-data">实际得A比例:<span class="num">{{currentSum.realityProportionA || 0}}</span></span> -->
        <!-- <span class="item-data">实际得C比例:<span class="num">{{currentSum.realityProportionC || 0}}</span></span> -->
        <!-- <span class="item-data">超出A人数:<span class="num">{{currentSum.moreThanA || 0}}</span></span> -->
        <!-- <span class="item-data">缺少C人数:<span class="num">{{currentSum.lessThanC || 0}}</span></span> -->
      </div>
      <div class="table-tabs">
        <div
          class="table-tab"
          v-for="tab in tabs"
          :class="{'table-tab--active': currentTab === tab.value}"
          @click="switchTab(tab.value)"
        >
          {{ tab.name }}
        </div>
      </div>
      <div class='table-content' v-show="currentTab === 0">
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          resizable
          :data="tableData"
          ref="table"
          @cell-click="expandRow"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildren}"
        >
          <vxe-table-column type="seq" show-overflow min-width="120" width="120" title="NO." tree-node></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="150" title="姓名">
            <template #default="{ row }">
              <span class="name-col" v-if="(row.category === 'Month' && row.workScoreInfo) || (row.category === 'Year' && row.yearScoreInfo)" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <span v-else>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="150" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
              <span v-if="row.isRatingCurnt">是</span>
              <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总成绩" width="70"></vxe-table-column>

          <vxe-table-column width="90" field="ratingResult" title="评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="评级状态" min-width="95">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else type="ongoing" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="考核表状态" min-width="95">
            <template #default="{ row }">
              <template v-if="row.workScoreInfo">
                <el-tag v-if="row.workScoreInfo.status === 0 || row.workScoreInfo.status === 20 || row.workScoreInfo.status === 30 || row.workScoreInfo.status === 40 || row.workScoreInfo.status === 50" type="complete" effect="dark">
                  {{ workscoreStatusMap[row.workScoreInfo.status] || '' }}
                </el-tag>
                <el-tag v-if="row.workScoreInfo.status === 10" type="close" effect="dark">
                  {{ workscoreStatusMap[row.workScoreInfo.status] || '' }}
                </el-tag>
              </template>
              <template v-else-if="row.yearScoreInfo">
                <el-tag type="complete" effect="dark">
                  {{ yearStatusMap[row.yearScoreInfo.status] || '' }}
                </el-tag>
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>
      <!-- 年计划考核 -->
      <div class='table-content' v-show="currentTab === 1">
        <div class="collapse" @click="yearCollapse($refs.table1)" :style="{'right': yearCollapseRight}">
          <i :class="[isYearCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table1"
          @cell-click="expandRow"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildren}"
        >
          <vxe-table-column type="seq" show-overflow min-width="120" width="120" title="NO." tree-node></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="150" title="姓名">
            <template #default="{ row }">
              <span class="name-col" v-if="row.yearScoreInfo" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <span v-else>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="150" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
              <span v-if="row.isRatingCurnt">是</span>
              <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总成绩" width="70"></vxe-table-column>

          <vxe-table-column width="90" field="ratingResult" title="评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="评级状态" min-width="95">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else type="ongoing" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="考核表状态" min-width="95">
            <template #default="{ row }">
              <template v-if="row.yearScoreInfo">
                <el-tag type="complete" effect="dark">
                  {{ yearStatusMap[row.yearScoreInfo.status] || '' }}
                </el-tag>
              </template>
            </template>
          </vxe-table-column>
          <!-- 折叠分数 -->
          <vxe-table-column
            v-for="classifyColumn in workClassifyColumns"
            :key="classifyColumn.field"
            :field="classifyColumn.field"
            width="110"
            :title="classifyColumn.name"
            :visible="isShowYearPlan"
            fixed="right"
          >
            <template #default="{row}">
              <div>{{row[classifyColumn.field]}}</div>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column field="classify0" width="110" title="重要KPI成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify0}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify10" width="100" title="业务成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify10}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify20" width="110" title="费效管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify20}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify30" width="150" title="人力资源管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify30}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify40" width="150" title="企业文化管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify40}}</div>
            </template>
          </vxe-table-column> -->
        </vxe-table>

      </div>

      <!-- 员工绩效参考 -->
      <div class='table-content' v-show="currentTab === 2">
        <div class="collapse" @click="personCollapse($refs.table2)" :style="{'right': personCollapseRight}">
          <i :class="[isPersonCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table2"
          @cell-click="expandRow"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildren}"
        >
          <vxe-table-column type="seq" show-overflow min-width="120" width="120" title="NO." tree-node></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="150" title="姓名">
            <template #default="{ row }">
              <span class="name-col" v-if="row.workScoreInfo" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <span v-else>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="150" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
              <span v-if="row.isRatingCurnt">是</span>
              <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总成绩" width="70"></vxe-table-column>

          <vxe-table-column width="90" field="ratingResult" title="评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="评级状态" min-width="95">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else type="ongoing" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="考核表状态" min-width="95">
            <template #default="{ row }">
              <template v-if="row.workScoreInfo">
                <el-tag v-if="row.workScoreInfo.status === 0 || row.workScoreInfo.status === 20 || row.workScoreInfo.status === 30 || row.workScoreInfo.status === 40 || row.workScoreInfo.status === 50" type="complete" effect="dark">
                  {{ workscoreStatusMap[row.workScoreInfo.status] || '' }}
                </el-tag>
                <el-tag v-if="row.workScoreInfo.status === 10" type="close" effect="dark">
                  {{ workscoreStatusMap[row.workScoreInfo.status] || '' }}
                </el-tag>
              </template>
            </template>
          </vxe-table-column>
          <!-- 折叠分数 -->
          <vxe-table-column field="classify100" width="80" title="绩效成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify100}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify110" width="80" title="企业文化导向成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify110}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify120" width="80" title="个人成长成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify120}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify130" width="80" title="OEC综合成绩" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify130}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-for="col in monthColumns"
            :field="col.field"
            :width="col.width"
            :title="col.title"
            :fixed="col.fixed"
            :visible="isShowPerson"
            :key="col.field"
            class-name='col-small'
            header-class-name='col-small'
          >
          </vxe-table-column>
        </vxe-table>

      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          v-show="currentTab === 0"
          background
          :current-page.sync="page.pageIndex"
          :page-size.sync="page.pageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 1"
          background
          :current-page.sync="yearPage.pageIndex"
          :page-size.sync="yearPage.pageSize"
          :total="yearTotal"
          height="100%"
          @page-change="yearPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 2"
          background
          :current-page.sync="personPage.pageIndex"
          :page-size.sync="personPage.pageSize"
          :total="personTotal"
          height="100%"
          @page-change="personPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <common-dialog ref="commonDialog" title="期次范围选择" width="530px" showClose :appendBody="true">
      <template slot="content">
        <exportComponent :param="exportParams"></exportComponent>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import _ from 'lodash';
  import {
    CLASSIFY_MAP,
    EDITDABLE_CLASSIFY,
    PERIODS,
    PERIOD_LIST,
    OEC_LEVEL,
    WORK_SCORE,
    IMPORTANCE_STATE,
    YEAR_PLAN_STATUS,
  } from '@/utils/period-enum.js';
  import periodMixin from '@/mixins/period.mixin';
  import workscoreMixin from '@/mixins/workscore.mixin.js';

  export default {
    components: {
      selecter: () => import('@/component/global/customerSelect'),
      exportComponent:()=>import('./export.vue'),
    },
    name: "periodHistory",
    mixins: [periodMixin, workscoreMixin],
    data() {
      return {
        tabs: [
          { name: '全部', value: 0, key: 'all', category: '' },
          { name: '年计划考核', value: 1, key: 'year', category: 'Year' },
          { name: '员工绩效考核', value: 2, key: 'person', category: 'Month' },
        ],
        currentTab: 0,
        isYearCollapse: true,
        isPersonCollapse: true,
        yearCollapseRight: 0,
        personCollapseRight: 0,
        classifyMap: CLASSIFY_MAP,
        editableClassify: EDITDABLE_CLASSIFY,
        
        periods: PERIODS,
        periodList: PERIOD_LIST,

        oecLevel: OEC_LEVEL,

        categoryList: [
          {label: '年计划考核', value: 'Year' },
          {label: '员工绩效考核', value: 'Month' },
        ],

        searchParam: {
          wkNo: '',
          wkName: '',
          superiorNo: '',
          superiorName:'',
          oecResult: '',
          year: undefined,
          period: undefined,
        },
        page: {
          pageIndex: 1,
          pageSize: 10
        },
        total: 0,
        tableData: [],

        yearPage: {
          pageIndex: 1,
          pageSize: 10
        },
        yearTotal: 0,

        personPage: {
          pageIndex: 1,
          pageSize: 10
        },
        personTotal: 0,

        currentSum: {},
        summary: {},

        warnNum: 'warn-num',
        nomalNum: 'num',

        statusMap: IMPORTANCE_STATE,
        workscoreStatusMap: WORK_SCORE,
        yearStatusMap: YEAR_PLAN_STATUS,

        oecStatusList: [
          { "itemValue": "0", "itemDesc": "未填报" },
          { "itemValue": "10", "itemDesc": "已驳回" },
          { "itemValue": "20", "itemDesc": "已填报" },
          { "itemValue": "30", "itemDesc": "已审批" },
          { "itemValue": "40", "itemDesc": "已公示" }
        ],
  
        currWkNo: '',
        wkNo: '',
        msgId: '',
        status: '',

        isShowYearPlan: false,
        isShowPerson: false,
        monthColumns: [
          {field: 'm1', title: '1月',  width: 35, fixed: 'right'},
          {field: 'm2', title: '2月',  width: 35, fixed: 'right'},
          {field: 'm3', title: '3月',  width: 35, fixed: 'right'},
          {field: 'm4', title: '4月',  width: 35, fixed: 'right'},
          {field: 'm5', title: '5月',  width: 35, fixed: 'right'},
          {field: 'm6', title: '6月',  width: 35, fixed: 'right'},
          {field: 'm7', title: '7月',  width: 35, fixed: 'right'},
          {field: 'm8', title: '8月',  width: 35, fixed: 'right'},
          {field: 'm9', title: '9月',  width: 35, fixed: 'right'},
          {field: 'm10', title: '10月',  width: 40, fixed: 'right'},
          {field: 'm11', title: '11月',  width: 40, fixed: 'right'},
          {field: 'm12', title: '12月',  width: 40, fixed: 'right'},
        ],

        classifyPrefix: 'classify',

        depData:[],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        depList: [],
        checkId: "",
        department: '',
        copyTreeData: [],
        departmentNo: '',
        expandedData: [],
        isDynamicEffective: true, // 是否启用动态版本
        workClassifyColumns: [],
      }
    },
    computed: {
      exportParams() {
        let tab = this.tabs.find(item => item.value === this.currentTab);
        let category = tab ? tab.category : '';
        return {
          loginWkNo: this.currWkNo,
          ...this.searchParam,
          year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
          period: this.searchParam.period || undefined,
          category,
          departmentNo: this.departmentNo
        }
      }
    },
    created() {
      this.wkNo = this.$route.query.wkNo || '';
      this.msgId = this.$route.query.msgId || '';
      this.date = this.$route.query.date || '';
    },
    mounted() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
      this.getDep();
      this.getList();
    },
    activated() {
      this.getList();
    },
    methods: {
      switchTab(tabIndex) {
        this.currentTab = tabIndex;
        this.getList();
      },
      yearCollapse(el) {
        this.isYearCollapse = !this.isYearCollapse;
        if (this.isYearCollapse) {
          this.hideYearPlan();
        } else {
          this.showYearPlan();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setYearPosition();
        });
      },
      showYearPlan() {
        this.isShowYearPlan = true;
      },
      hideYearPlan() {
        this.isShowYearPlan = false;
      },
      setYearPosition() {
        if (this.isYearCollapse) {
          this.yearCollapseRight = '0';
        } else {
          const ell = this.$refs.table1.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')
          let fixedWidth = ell ? ell[0].offsetWidth : 0;
          this.yearCollapseRight = fixedWidth + 'px';
        }
      },

      personCollapse(el) {
        this.isPersonCollapse = !this.isPersonCollapse;
        if (this.isPersonCollapse) {
          this.hidePerson();
        } else {
          this.showPerson();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setPersonPosition();
        });
      },
      showPerson() {
        this.isShowPerson = true;
      },
      hidePerson() {
        this.isShowPerson = false;
      },
      setPersonPosition() {
        setTimeout(() => {
          if (this.isPersonCollapse) {
            this.personCollapseRight = '0';
          } else {
            let fixedWidth = this.$refs.table2.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth;
            this.personCollapseRight = fixedWidth + 'px';
          }
        }, 10);
      },
      getCurrRateSum() {
        return new Promise(resolve => {
          let param = Object.assign(
            { loginWkNo: this.currWkNo },
            this.searchParam,
            this.page,
            {
              period: this.searchParam.period || undefined,
              year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
              departmentNo: this.departmentNo
            }
          )
          this.$ajax.put(this.$api.period.resultDeclare.searchRate, param).then((res) => {
            res.data ? resolve(res.data) : resolve({});
          });
        });
      },
      getList(resetPage) {
        this.setValid(1);
        this.$refs['searchForm'].validate((valid, errors) => {
          if (valid) {
            if (resetPage) {
              this.page.pageIndex = 1;
              this.yearPage.pageIndex = 1;
              this.personPage.pageIndex = 1;
            }
            if (this.wkNo) {
              this.currWkNo = this.wkNo;
            }
            let page = this.page;
            switch (this.currentTab) {
              case 0:
                page = this.page;
                break;
              case 1:
                page = this.yearPage;
                break;
              case 2:
                page = this.personPage;
                break;
              default:
                break;
            }
            let tab = this.tabs.find(item => item.value === this.currentTab);
            let category = tab ? tab.category : '';
            let param = Object.assign(
              { loginWkNo: this.currWkNo, category },
              this.searchParam,
              {
                year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
                period: this.searchParam.period || undefined,
                departmentNo: this.departmentNo
              },
              page
            );
            this.getDynamicClassify({year: this.searchParam.year, period: this.searchParam.period});
            this.$ajax.put(this.$api.period.resultDeclare.search, param).then(async (res) => {
              let resList = res.data.rows || [];
              resList = resList.map(p => {
                p.parentId = null;
                p.hasChild = p.isOrLeader ? true : false;
                return p;
              });
              let tableDatas = [];
              resList.forEach(item => {
                let rowData = {
                  ...item.periodResultInfo,
                  ...item,
                };
                let monthData = item.oecResultInfo || [];

                for (let i = 0; i < this.monthColumns.length; i++) {
                  rowData[this.monthColumns[i]] = '';
                }
                monthData.forEach(p => {
                  rowData['m' + p.month] = p.ratingResult || '';
                });

                let classifyData = item.periodClassifyScoreInfo || [];
                for (const key in this.classifyMap) {
                  rowData[this.classifyPrefix + key] = '';
                }
                classifyData.forEach(c => {
                  rowData[this.classifyPrefix + c.workClassify] = c.score;
                });

                tableDatas.push(rowData);
              });
              this.tableData = tableDatas;
              
              switch (this.currentTab) {
                case 0:
                  this.total = res.data.total;
                  break;
                case 1:
                  this.yearTotal = res.data.total;
                  this.handleDynamicColumn(res.data.classifyList || []);
                  break;
                case 2:
                  this.personTotal = res.data.total;
                  break;
                default:
                  break;
              }
              this.currentSum = await this.getCurrRateSum();
            });
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0);
        });
        
      },
      handleDynamicColumn(dynamicWorkClassify) {
        let workClassifyColumns = [];
        const defaultColumns = [
          {field: `${this.classifyPrefix}0`, workClassify: 0, name: '重要KPI成绩' },
          {field: `${this.classifyPrefix}10`, workClassify: 10, name: '业务成绩' },
          {field: `${this.classifyPrefix}20`, workClassify: 20, name: '费效管理成绩' },
          {field: `${this.classifyPrefix}30`, workClassify: 30, name: '人力资源管理成绩' },
          {field: `${this.classifyPrefix}40`, workClassify: 40, name: '企业文化管理成绩' },
        ];
        if (dynamicWorkClassify.length > 0) {
          workClassifyColumns = dynamicWorkClassify.map((item) => {
            return {
              field: `${this.classifyPrefix}${item.workClassify}`,
              workClassify: item.workClassify,
              name: item.classifyName,
              type: item.type,
            }
          })
          workClassifyColumns = workClassifyColumns.filter((item) => ![3].includes(item.type))
        } else {
          workClassifyColumns = defaultColumns;
        }
        this.workClassifyColumns = workClassifyColumns;
      },
      loadChildren({row}) {
        return new Promise(resolve => {
          let tab = this.tabs.find(item => item.value === this.currentTab);
          let category = tab ? tab.category : '';
          let params = {
            parentWkNo: row.wkNo,
            pageIndex: 1,
            pageSize: 99999,
            category,
            year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
            period: this.searchParam.period || undefined,
            departmentNo: this.departmentNo
          };
          this.$ajax.put(this.$api.period.resultDeclare.search, params).then((res) => {
            if (res.data.rows.length) {
              let resList = res.data.rows || [];
              resList = resList.map(p => {
                p.parentId = null;
                p.hasChild = p.isOrLeader ? true : false;
                return p;
              });
              let tableDatas = [];
              resList.forEach(item => {
                let rowData = {
                  ...item.periodResultInfo,
                  ...item,
                };
                let monthData = item.oecResultInfo || [];

                for (let i = 0; i < this.monthColumns.length; i++) {
                  rowData[this.monthColumns[i]] = '';
                }
                monthData.forEach(p => {
                  rowData['m' + p.month] = p.ratingResult || '';
                });

                let classifyData = item.periodClassifyScoreInfo || [];
                for (const key in this.classifyMap) {
                  rowData[this.classifyPrefix + key] = '';
                }
                classifyData.forEach(c => {
                  rowData[this.classifyPrefix + c.workClassify] = c.score;
                });

                tableDatas.push(rowData);
              });
              resolve(tableDatas);
            } else {
              row.hasChild = false;
              resolve(row);
            }

          });
        });
      },
      // eslint-disable-next-line no-unused-vars
      expandRow({row, triggerTreeNode}) {
        if (triggerTreeNode) return;
        row.expandRowFlag = !row.expandRowFlag;
        let $table = this.$refs.table;
        if (this.currentTab === 1) {
          $table = this.$refs.table1;
        } else if (this.currentTab === 2) {
          $table = this.$refs.table2;
        }
        $table.updateData(this.tableData);
      },

      pageChange({currentPage}) {
        this.page.pageIndex = currentPage;
        this.getList();
      },
      yearPageChange({currentPage}) {
        this.yearPage.pageIndex = currentPage;
        this.getList();
      },
      personPageChange({currentPage}) {
        this.personPage.pageIndex = currentPage;
        this.getList();
      },

      getDep() {
        this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList = res.data || [];     
            const obj = {};
            this.depList.forEach(v => {
            const objClone = _.cloneDeep(obj);
            objClone.id = v.id,
            objClone.code = v.code,
            objClone.label = v.displayName
           if (v.parentId === null) {
              this.expandedData.push(v.id);
              objClone.children = this.depList.filter(t => t.parentId === v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
              this.copyTreeData = _.cloneDeep(this.treeData);
            }
          });
        });
      },
      generateMenu(chs){
        chs.forEach(v => {
          v.label = v.displayName
          v.children = this.depList.filter(t => t.parentId === v.id)
          this.generateMenu(v.children);
        });
      },
      getSimpleCheckedNodes(store) {
        const checkedNodes = [];
        const traverse = function(node) {
          const childNodes = node.root ? node.root.childNodes : node.childNodes;
          childNodes.forEach(child => {
            if (child.checked) {
              checkedNodes.push(child.data);
            }
            if (child.indeterminate) {
              traverse(child);
            }
          });
        };
        traverse(store)
        return checkedNodes;
      },
      handleCheckChange(data, checked){
        this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
        let code = [] , deptNmae = [];
        this.selectNode.forEach(t => {
          code.push(t.code);
          deptNmae.push(t.label);
        });
        this.departmentNo = code.join(",");
        this.department = deptNmae.join(",");
        // this.selectNode = this.formatToTree(selectData);
        // if(checked === true){
        //   this.checkId=data.id;
        //   this.departmentNo=data.code;
        //   this.department=data.label;
        //   // this.$refs.tree.setCheckedKeys([data.id]);
        // }else{
        //   if(this.checkId === data.id) {
        //     this.checkId='';
        //     this.departmentNo='';
        //     this.department='';
        //     // this.$refs.tree.setCheckedKeys([]);
        //   }
        // }
      },
      getChildrenMenu(depData){
        let depTree = [];
        depData.forEach(t => {
          if(t.label.indexOf(this.department) != -1){
          depTree.push(t)
          }else{
            if(t.children && t.children && t.children.length){
              t.children = this.getChildrenMenu(t.children)
              if(t.children && t.children.length){
                depTree.push(t)
              }
            }
          }
        });
        return this.treeData=depTree;
      },
      handledHide(){
        this.$nextTick(()=>{
          if(!this.$refs.tree.getCheckedKeys().length){
            this.department="";
          }
        });
      },

      exportExcel() {
        this.setValid(1);
        this.$refs['searchForm'].validate((valid, errors) => {
          if (valid) {
            this.$ajax.get(this.$api.period.resultDeclare.export, this.exportParams, {ignore: true, responseType: 'blob'}).then((res) => {
              if (res.data.type == 'application/json') {
                var reader = new FileReader();
                reader.onload = () => {
                  var content = reader.result;//内容就在这里
                  let json = JSON.parse(content)
                  this.$message.error(json.message)
                };
                reader.readAsText(res.data);
              } else {
                const filename = '综合绩效查询'
                const filetype = 'xlsx'
                let data = res.data;
                let url = window.URL.createObjectURL(data)
                let a = document.createElement('a')
                document.body.appendChild(a)
                a.href = url
                a.download = filename + '.' + filetype
                a.click()
                window.URL.revokeObjectURL(url)
              }
            });
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0);
        })
      },
      exportMulti(){
        this.$refs.commonDialog.show();
      },
      exportTask() {
        this.setValid(1);
        this.$refs['searchForm'].validate((valid, errors) => {
          if (valid) {
            this.$ajax
              .get(this.$api.period.resultDeclare.taskExport, this.exportParams)
              .then((res) => {
                if (res.code === 0) {
                  this.$router.push({
                    path: '/manage/export-task/index',
                  });
                }
              })
              .catch(() => {});
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0);
        })
      },
      toPage(row) {
        if (row.category === 'Month') {
          this.$router.push({path: '/personal/workscore/detail', query: { id: row.workScoreInfo.id, editStatus: 'approve' }});
        } else if (row.category === 'Year') {
          let pagePath = '/personal/workscore/yearDetail';
          if (this.isDynamicEffective && row.yearScoreInfo.versionId) {
            pagePath = '/personal/workscore/yearDetailNext';
          }
          this.$router.push({path: pagePath, query: { id: row.yearScoreInfo.id, editStatus: 'approve' }});
        }
      },
    },
    watch: {
      department: {
        handler(val){
          if(!val){
            this.departmentNo = "";
            this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
          }
        },
        immediate:true
      }
    }
  }
</script>
<style scoped lang='scss'>
  .declare-page {
    height: 100%;
    .search {
      .atb-input {
        display: flex;
        flex-direction: column;
        .query-where {
          display: flex;
          .flex-form-item {
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content {
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
          }
        }
        .query-operation {
          display: flex;
        }
      }
    }
    .table-content {
      position: relative;
    }
    .atb-content-bg {
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab {
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    .summary {
      font-size: 14px;
      color: #4a5150;
      .item-data {
        display: inline-block;
        margin-bottom: 12px;
        margin-right: 30px;
        .cursor{
          cursor: pointer;
        }
        .num {
          font-weight: bolder;
          color: #22b6a1;
          padding: 10px;
        }
        .warn-num {
          font-weight: bolder;
          color: #fe6562;
          padding: 10px;
        }
      }
    }
  }
  .name-col {
    cursor: pointer;
    color: $--color-primary;
  }
  .collapse {
    margin-top: -15px;
    position: absolute;
    top: 50%;
    right: 0;
    width: 15px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: rgba(#000, 0.1);
    z-index: 99;
    cursor: pointer;
    &:hover {
      background-color: rgba(#000, 0.2);
    }
    i {
      font-size: 14px;
      color: #fff;
    }
  }
  .table-tabs {
    .table-tab {
      display: inline-block;
      margin: 0 8px 12px;
      padding: 8px 10px;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      border: 1px solid $--color-primary;
      background-color: #d8f5f1;
      color: $--color-primary;
      &:hover, &.table-tab--active {
        background-color: $--color-primary;
        color: #fff;
      }
    }
    
  }
</style>